// extracted by mini-css-extract-plugin
export var content = "mail-confirmation-module--content--v7yX7";
export var layout = "mail-confirmation-module--layout--8CJuD";